<template>
  <div
      v-title
      v-loading="loading"
      title="产品列表"
      element-loading-text="数据加载中"
      style="height:100%;">
    <div class="searchBox">
      <el-input v-model="filter.name" prefix-icon="el-icon-search" placeholder="请输入文件名称" @change="getData"/>
    </div>
    <div style="padding-top:55px;overflow:hidden">
      <div v-for="item in productList" :key="item.id" class="productList" @click.stop="read(item.id)">
        <div class="fileType">
          <img v-if="item.name.split('.')[item.name.split('.').length -1] === 'pdf'" src="../../../public/img/pdf.png" alt="" srcset="">
          <img v-else src="../../../public/img/docx.png" alt="" srcset="">
        </div>
        <div class="fileName">
          {{item.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        loading:false,
        filter: {
          name: "",
          type: 128,
        },
        productList: [],
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        this.$http.get("basic", "pans/public/list",this.filter).then((res) => {
          res.forEach(item => {
            item.fileType = item.name.split(".")[item.name.split(".").length - 1];
          });
          this.productList = res;
          this.loading = false;
        });
      },
      read(id) {
        window.open("#/pdf?id=" + id);
      },
    },
  };
</script>

<style>
.searchBox {
  width: 100%;
  padding: 10px;
  box-shadow:0px 0px 5px 0px #aaa;
  position: fixed;
  z-index: 999999;
  background-color: #f4f4f4;
  box-sizing: border-box;
}
.searchBox .el-input__inner {
  height: 32px!important;
  border-radius: 16px;
}
.productList {
  display: flex;
  border-bottom: 1px solid #f4f4f4;
  padding: 5px 10px;
  align-items: center;
}
.fileType {
  width: 50px;
}
.fileType img {
  width: 40px;
  height: 40px;
}
.fileName {
  flex: 1;
  font-size: 14px;
}
</style>
